module.exports = "https://cdn.dove.it/_next/static/public/assets/agents/all.52887b306ef1deb37aa9b7465a2d1e3a.jpg";